var viewer_caption_rtlignore_default = {
  "fontElementMap": "zgm0-",
  "imageCaption": "JlS9j"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
